import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { MOBILE_WIDTH } from "../../constants/otherConstants";
import useWindowDimensions from "../../WindowDimensions-hook/useWindowDimensions";

import * as actionTypes from "../../store/actions";

import Timer from "./Timer";
import "./TicketHeader.css";

const TicketHeader = (props) => {

  const { width } = useWindowDimensions();

  const categoryTickets = props.categoryTickets;
  const errorsSubTitle = "Работа над ошибками";

  const onExitClick = () => {
    if (categoryTickets === "errorsAB" || categoryTickets === "errorsCD") {
      let errorsArray = JSON.parse(localStorage.getItem("errorsArray"));
      if (errorsArray !== null) {
        errorsArray = errorsArray.filter((el) => el.ticketErrors.length !== 0);
        if (errorsArray.length === 0) localStorage.removeItem("errorsArray");
        else {
          localStorage.setItem("errorsArray", JSON.stringify(errorsArray));
        }
      }
    }
    props.resetToInitialState();
    window.scrollTo(0, 0);
  };


  return (
    <>
      {
        width > MOBILE_WIDTH &&
        <div className="ticket-header">
          <Link onClick={onExitClick} className="easy-pointer" to={"/"}>
            <i className="fas fa-chevron-left" title="Вернуться на Главную"></i>
          </Link>
          <h1
            style={{ margin: "0" }}
            className={
              categoryTickets === "errorsAB" || categoryTickets === "errorsCD"
                ? "dash-header error-header center-text"
                : props.notToRenderTimer !== undefined
                  ? "dash-header error-header center-text"
                  : "center-text"
            }
          >
            {categoryTickets === "errorsAB" || categoryTickets === "errorsCD" ? (
              <div>{errorsSubTitle}</div>
            ) : (
              ""
            )}
            {props.currentTicketHeader}
          </h1>
          {props.notToRenderTimer === undefined ? (
            <Timer color={props.timerColor} categoryTickets={categoryTickets} />
          ) : (
            <div></div>
          )} 
        </div>
      }
    </>
  );
};


const mapDispatchToProps = (dispatch) => {
  return {
    resetToInitialState: () =>
      dispatch({
        type: actionTypes.RESET_TO_INITIAL_STATE,
      }),
  };
};

const mapStateToProps = (state) => {
  return {
    categoryTickets: state.router.location.pathname.split("/")[1],
    numbersStateArray: state.ticketsReducer.numbersStateArray,
    loadedBilet: state.ticketsReducer.loadedBilet,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketHeader);
